import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { PublicHttpClient } from 'src/core/public-http.service';

export type XhrLogin = {
    access_token: string;
    refresh_token: string;
    Profile: { Uid: string };
};

export type XhrRefresh = {
    access_token: string;
    access_token_de: string;
    access_token_ea: string;
    access_token_ef: string;
    uid: string;
};

export type XhrGoogleAuth = {
    access_token: string;
    refresh_token: string;
};

export interface IloginByEmailRequestPayload {
    email: string;
    password: string;
}

@Injectable({
    providedIn: 'root',
})
export class LoginProvider {
    constructor(private publicHttp: PublicHttpClient) {}

    lrLogin(payload: IloginByEmailRequestPayload): Promise<XhrLogin> {
        const { urls } = environment;
        return this.publicHttp.post<XhrLogin>(`${urls.v2}lr/login`, payload);
    }

    refresh(uId: string, accessToken: string): Promise<XhrRefresh> {
        const { urls } = environment;
        return this.publicHttp.get<XhrRefresh>(`${urls.v2}session/${uId}?refresh=true`, {}, accessToken);
    }

    googleAuth(authToken: string): Promise<XhrGoogleAuth> {
        const { urls, commonOptions } = environment;
        return this.publicHttp.get<XhrGoogleAuth>(
            `${urls.loginRadius}api/v2/access_token/google?google_access_token=${authToken}&key=${commonOptions.loginRadiusClientId}`
        );
    }
}
